import { listCCEmailsByClientId } from '../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from "aws-amplify/api";

const client = generateClient();

export const fetchCCEmailsByClientId = async (clientId) => {
  if (clientId) {
    try {
      const response = await client.graphql({
        query: listCCEmailsByClientId,
        variables: {
          clientId: clientId, 
          filter: { isActive: { eq: true }, isVerified: { eq: true } }
        }
      });

      // console.log('response: ', response)
      const results = response.data.ccEmailsByClientId.items;
      return results;
    } catch(err) {
      return ('error fetchCCEmailsByClientId: ', [err]);
    }
  } else {
    return 'Missing params';
  }
};

fetchCCEmailsByClientId.propTypes = {
  clientId: PropTypes.string.isRequired,
};
